import React, { useContext, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import '../styles/Page.css';
import { LoadingContext } from './context/LoadingContext';
import usePrefetch from '../hooks/usePrefetch';
import NotFound from './NotFound';
import hasStoreName from '../helpers/hasStoreName';
import AppContext from './context/AppContext';
import Spinner from 'react-bootstrap/Spinner';
import PageContent from './PageContent';
// Page fetching func.
const fetchPage = async (handle = '') => {
    const response = await fetch(new URL(`/api/pages/handle/${handle}`, process.env.APP_URL));
    const data = await response.json();
    return data?.page ?? null;
};

const Page = () => {
    const { appContext } = useContext(AppContext);

    // Loading state
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    const { handle } = useParams();
    const {
        isLoaded: pageDataLoaded,
        data: pageData,
    } = usePrefetch({
        key: 'page',
        resourceKey: 'handle',
        resourceValue: handle,
        prefetchFn: async () => {
            await startLoading();
            const data = await fetchPage(handle);
            await finishLoading();
            return data;
        }
    });

    /** Add store name to title if not exists */
    const title = useMemo(() => {
        if (!pageDataLoaded
            || !pageData
            || !Object.keys(pageData).length > 0) {
            return '';
        }
        let title = pageData.title;
        if (!hasStoreName(title, appContext.config.storeName)) {
            title = `${title} - ${appContext.config.storeName}`;
        }
        return title;
    }, [pageDataLoaded, pageData]);

    if (pageDataLoaded === true && (!pageData || Object.keys(pageData ?? {}).length === 0)) {
        return (<NotFound />);
    }

    return (
        <Container
            fluid>
            <div
                className={'section'}>
                {!pageDataLoaded ? (
                    <div
                        className={'loading-container'}>
                        <Spinner
                            animation={'border'}
                            variant={'primary'}>
                            <span
                                className={'visually-hidden'}>Loading...</span>
                        </Spinner>
                    </div>
                ) : <PageContent
                    pageData={pageData}
                    title={title}
                    handle={handle} />}
            </div>
        </Container>
    );
};

export default Page;